import { Prisma } from "db"

export const articleTagsVX = Prisma.validator<Prisma.TagFindManyArgs>()({
  select: {
    translations: {
      orderBy: { locale: "asc" },
      select: { locale: true, name: true, slug: true },
    },
  },
  where: {
    publishedAt: {
      not: null,
    },
  },
})
